import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/MechatronicsProducts.module.css";
import img1 from "../../../images/Conveyor-System.jpg";
import img2 from "../../../images/Laser-Marking.jpg";
import img3 from "../../../images/Robotic-Solution.jpg";
import img4 from "../../../images/Servo-Press.jpg";
import img5 from "../../../images/Servo-Press-2.jpg";
import img6 from "../../../images/Nut-Runner.jpg";
import img7 from "../../../images/Robotic-Solutions.jpg";
import img8 from "../../../images/SPM.jpg";

const products = [
  {
    title: "CONVEYOR SYSTEM",
    image: img1,
    description: [
      "Aluminium Profile Belt/ Plastic Chain conveyor for material handling",
      "PLC / VFD Controlled",
      "Custom design as per requirement",
    ],
  },
  {
    title: "LASER MARKING STATION",
    image: img2,
    description: [
      "Designed for automotive industry",
      "Dual station loading/unloading on rotary table",
      "Closed chamber for laser",
      "Minimized cycle time with dual station",
      "Custom design available as per requirement",
    ],
  },
  {
    title: "ROBOTIC SOLUTIONS",
    image:img3,
    description: [
      "Online measurement of automotive component using robotic arm",
      "Standard / custom solution for measuring devices from Mitutoyo, Renishaw, Keyence",
    ],
  },
  {
    title: "SERVO PRESS",
    image: img4,
    description: [
      "Precision pressing, riveting, bending, drawing, engraving, testing applications",
      "Range from 1 ton to 20 ton",
      "Load display on HMI",
      "Load vs displacement graph (optional)",
    ],
  },
  {
    title: "SERVO PRESS",
    image: img5,
    description: [
      "Precision pressing, riveting, bending, drawing, engraving, testing applications",
      "Range from 1 ton to 20 ton",
      "Load display on HMI",
      "Load vs displacement graph (optional)",
    ],
  },
  {
    title: "SPECIAL PURPOSE MACHINE",
    image: img6,
    description: [
      "Automatic bearing, loading and pressing machine",
      "Automatic loading of bearing from magazine",
      "Dual Magazine for maximum productivity",
      "Auto loading eliminates grease marks on components",
      "High speed loading and pressing",
    ],
  },
  {
    title: "ROBOTIC SOLUTIONS",
    image: img7,
    description: [
      "Screw tightening application",
      "Glue dispensing application",
      "Pick-n-place application",
      "Vision inspection",
      "Robot vision with conveyor synchronization",
    ],
  },
  {
    title: "NUT RUNNER APPLICATION",
    image: img8,
    description: [
      "Special purpose machine for automotive",
      "Stepper motor screw tightening for throttle body",
      "Screw torque setting via HMI",
      "Oil dispensing via controller",
    ],
  },
];

function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, visible];
}

function Reveal({ children, delay = 0 }) {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={styles.reveal}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(24px)",
        transition: `opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

export default function MechatronicsProducts() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>MECHATRONICS PRODUCTS</h2>
        <div className={styles.grid}>
          {products.map((product, index) => (
            <Reveal key={index} delay={index * 60}>
              <article className={styles.product}>
                <div className={styles.imageWrap}>
                  <img
                    src={product.image}
                    alt={product.title}
                    className={styles.productImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.productTitle}>{product.title}</h3>
                <ul className={styles.productList}>
                  {product.description.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
